import type { Task } from "@gearbox-protocol/deploy-tools-shared";
import { ErrorBox, Loading } from "@gearbox-protocol/deploy-tools-ui";
import type { FC } from "react";

import PoolInsolvencyCard from "./PoolInsolvencyCard";
import useInsolvencyReport from "./useInsolvencyReport";

interface InsolvencyReportProps {
  task: Task;
}

export const InsolvencyReport: FC<InsolvencyReportProps> = ({ task }) => {
  const { loading, error, value } = useInsolvencyReport(task);
  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <ErrorBox error={error} />;
  }
  if (value?.errors.length) {
    return <ErrorBox>{value.errors.join("\n")}</ErrorBox>;
  }
  return value?.pools.map(pool => {
    return <PoolInsolvencyCard key={pool.pool} pool={pool} />;
  });
};
